Librarian.Modules.MyBookmarks = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["viewAll", "prepCartItem"],

    options: {
        classPrefix: "modules-bookmarks-",
        label: null,
        detailed: false,
        showGetLink: false,
        showShareLink: true,
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        var self = this;

        if (!this.wrapperEl) {
            return;
        }

        this.parent();

        var url = Librarian.path.getMethodUrl("getbmitms") + "&cid=0&out=ljson&fvname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES];
        
        this.request = new Librarian.Request.JSON({
            url: url,
            method: "get",
            onSuccess: function (response) {
                if (self.options.viewAll) {
                    // add view all button
                    new Element("span", {
                        "class": "viewAll",
                        events: {
                            click: function (event) {
                                Librarian.MyFiles.filter = {};
                                Librarian.MyFiles.filter["BookmarkedFiles"] = true;

                                Library.myFilesClicked();
                                Librarian.Init.toggleSideColumn(sideColumn, true, false);
                            }
                        },
                        text: "View all"
                    }).injectInside(self.headerEl);
                }
                response.forEach(function(item) {
                    var linkEl = new Element("div", {
                        "class": "file-link",                       
                    }).injectInside(self.containerEl);

                    new Element("img", {
                        "class": "file-link-icon",
                        src: Librarian.Utils.getContentTypeIcon(item)
                    }).injectInside(linkEl);

                    new Element("span", {
                        "class": "file-link-text",
                        text: item.name,
                        title: item.name,
                        events: {
                            click: function(event) {
                                self.clickHandler(event, item);
                            }
                        }
                    }).injectInside(linkEl);

                    if (self.options.detailed) {
                        var bookmarkEl = new Element("div", {
                            "class": "content-bookmark"
                        }).injectInside(linkEl);

                        Librarian.Bookmarks.getBookmarkId(item.contentid,
                            item.contenttype,
                            function(bookmarkId) {
                                if (bookmarkId > 0) {
                                    bookmarkEl.addClass("bookmarked");
                                    bookmarkEl.bookmarkId = bookmarkId;
                                }
                            });

                        var threeDotEl = new Element("div", {
                            "class": "content-menu-icon"
                        }).injectInside(linkEl);

                        var menuEl = new Element("div", {
                            "class": "content-menu-wrapper"
                        }).injectInside(linkEl);

                        var downloadEl = new Element("div", {
                            "text": "Download"
                        }).injectInside(menuEl);

                        var cartEl = new Element("div", {
                            "text": "Add File"
                        }).injectInside(menuEl);

                        if (self.options.showShareLink) {
                            var shareEl = new Element("div", {
                                "text": "Share"
                            }).injectInside(menuEl);
                        }

                        var viewEl = new Element("div", {
                            "text": "View in Library"
                        }).injectInside(menuEl);

                        if (self.options.showGetLink) {
                            var getLinkEl = new Element("div", {
                                "text": "Get Link"
                            }).injectInside(menuEl);

                            getLinkEl.addOnClick(function () {
                                Librarian.Utils.getLink(item);
                            });
                        }

                        menuEl.hide();

                        threeDotEl.addEvent('mouseenter', function() {
                            menuEl.show();
                            menuEl.removeClass("open-above");

                            var menuRect = menuEl.getBoundingClientRect();
                            var contRect = self.containerEl.getBoundingClientRect();
                            var openAbove = menuRect.bottom > contRect.bottom;
                            
                            menuEl.toggleClass("open-above", openAbove);

                            menuRect = menuEl.getBoundingClientRect();
                            var openLeft = menuRect.top < contRect.top;

                            menuEl.toggleClass("open-left", (openAbove && openLeft));

                            threeDotEl.addClass("active");
                        });

                        menuEl.addEvent('mouseenter', function() {
                            menuEl.show();
                            threeDotEl.addClass("active");
                        });

                        threeDotEl.addEvent('mouseleave', function() {
                            menuEl.hide();
                            threeDotEl.removeClass("active");
                        });

                        menuEl.addEvent('mouseleave', function() {
                            menuEl.hide();
                            threeDotEl.removeClass("active");
                        });

                        downloadEl.addOnClick(function () {
                            Library.downloadData(item);
                        });

                        cartEl.addOnClick(function () {
                        // Can't add to the cart if we don't have a cart
                            if (!Librarian.userCart)
                                return;

                            var cartItem = self.prepCartItem(item, 1),
                                onComplete = function(success, notifyType) {
                                    Librarian.Utils.showCartNotification(cartItem, notifyType, success);

                                    // Update the checkboxes on the main page
                                    Librarian.Utils.updateAllCheckboxes();

                                    Librarian.Cart.onChange();

                                    // If we're in the cart and we just removed ourselves,
                                    // close the window to prevent switching errors.
                                    if (success && (notifyType == Librarian.cartNotificationTypes.removed) && this.isInCart)
                                        this.close();
                                }.bind(this);

                            // If it's already in the cart, prompt the user to remove it
                            if (Librarian.userCart.isInCart(cartItem, true)) {
                                Librarian.userCart.removeFromCart(item, null, null, null, null, function() {
                                    onComplete(!Librarian.userCart.isInCart(cartItem), Librarian.cartNotificationTypes.removed);
                                });
                            }
                                // Otherwise, add it
                            else
                                onComplete(Librarian.userCart.addToCart(cartItem), Librarian.cartNotificationTypes.added);
                        });

                        if (shareEl) {
                            shareEl.addOnClick(function () {
                                var eventType = Librarian.eventType.oneOff;
                                this.sendWindow = new Librarian.EventSendWindow({
                                    onCloseComplete: function () {
                                        this.sendFileWindow = null;
                                    }.bind(this),
                                    eventType: eventType
                                }, item);
                                this.sendWindow.show();
                            });
                        }

                        viewEl.addOnClick(function () {
                            var tree = Library.getTreeByType(Librarian.catType.file, null, item.prestype);
                            Librarian.Utils.getPath(item, function(path) {
                                if (path != null)
                                    Library.loadLibraryTab();
                                    Librarian.Utils.selectTreeNodeByPath(tree, path);
                            });
                        });

                        new Element('span', {
                            "class": "content-field",
                            "text": "Last Modifed: " + Librarian.Utils.getDateValue(item.lastmoddate, "%x %X")
                        }).injectInside(linkEl);

                        new Element('span', {
                            "class": "content-field",
                            "text": "Author: " + (item.extrafields.Author || "")
                        }).injectInside(linkEl);

                        bookmarkEl.addOnClick(function() {
                            var self = this;
                            if (this.hasClass("bookmarked")) {
                                Librarian.Bookmarks.deleteBookmark(this.bookmarkId,
                                    item.contentid,
                                    item.contenttype,
                                    function() {
                                        self.removeClass("bookmarked");
                                    }.bind(this));

                            } else {
                                Librarian.Bookmarks.addBookmark(item.contentid,
                                    item.contenttype,
                                    function(bookmarkId) {
                                        self.addClass("bookmarked");
                                        this.bookmarkId = bookmarkId;
                                    }.bind(this));
                            }
                        });
                    }
                });
            }
        });
        this.request.send();   
    }, 

    clickHandler: function (event, file) {
        event.stopPropagation();
        Librarian.PreviewWindow.openPreviewWindow(file);
    },

    viewAll: function (event, response) {

            Librarian.Homepage.hide();
            if (Librarian.features.mountedVuePages.load)
                Librarian.Modules.MountedVuePage.hide();

            tileList.loadFromArray(response.presentations);

            var itemEl = $("pageheader");
            if (itemEl) {
                itemEl.show();
            }

            if(Librarian.pageheader != null) {
                Librarian.pageHeader.destroy();
                Librarian.pageHeader = null;
            }

            $('myInProgress').empty();

            Librarian.pageHeader = new Librarian.PageHeader({
                name: "My Favorites",
                showHeaderMenu: false
            });
    },

    prepCartItem: function (data, type) {
        if (!Librarian.Cart)
            return data;

        var item = new Librarian.Cart.Item(data);
        if ((type == Librarian.Utils.getItemTypeString(this.options.data)) && (this.options.data.slidenumber < 1))
            item.slidenumber = 1;
        // Files
        else if (type == Librarian.Lang.getString("item")) {
            if (this.options.data.slidenumber != 0)
                item.slidenumber = 0;
            item.itemnumber = undefined;
            if (this.options.data.slideid != 0)
                item.slideid = 0;
            // Restore the parent extra fields if we're adding this as an item
            if (this.options.parentData && this.options.parentData.extrafields)
                item.extrafields = this.options.parentData.extrafields;
        }
        // Slides/Pages
        // If there is parent data and they have extra fields, save the extrafields as parents fields
        else if (this.options.parentData && this.options.parentData.extrafields)
            item.parentfields = this.options.parentData.extrafields;

        // Reset the add type for this item so the cart can process it correctly
        item.addType = null;

        return item;
    }
});